import { FortIcon, TempleIcon } from '../components/icons/HeritageIcons';
import { Home, MapPin, Search, Menu, CalendarDays, Heart, Compass } from 'lucide-react';

/** Bottom tab roots — show tab bar on these paths only. */
export const MOBILE_TAB_ROUTES = [
  { id: 'home', to: '/', labelKey: 'mobile.tabs.home', Icon: Home },
  { id: 'forts', to: '/forts', labelKey: 'mobile.tabs.forts', Icon: FortIcon },
  { id: 'trek', to: '/trek-planner', labelKey: 'mobile.tabs.trek', Icon: MapPin },
  { id: 'temples', to: '/temples', labelKey: 'mobile.tabs.temples', Icon: TempleIcon },
  { id: 'menu', to: null, labelKey: 'mobile.tabs.menu', Icon: Menu, action: 'menu' },
];

/** Detail / auth screens — hide bottom bar, show back header. */
export const MOBILE_HIDE_TAB_PREFIXES = [
  '/fort/',
  '/temples/',
  '/wades/',
  '/blog/',
  '/shop/',
  '/organizations/org/',
  '/thematic-routes/',
  '/history/',
  '/login',
  '/register',
  '/admin',
  '/mobile/',
  '/profile',
  '/search',
  '/nearby-forts',
  '/events',
  '/heritage/',
  '/fort-guide',
  '/community',
  '/emergency',
];

export const MOBILE_QUICK_ACTIONS = [
  { to: '/nearby-forts', labelKey: 'mobile.actions.nearby', Icon: Compass, color: 'emerald' },
  { to: '/search', labelKey: 'mobile.actions.search', Icon: Search, color: 'amber' },
  { to: '/events', labelKey: 'mobile.actions.events', Icon: CalendarDays, color: 'rose' },
  { to: '/heritage', labelKey: 'mobile.actions.heritage', Icon: Heart, color: 'orange' },
];

export function shouldShowMobileTabBar(pathname) {
  if (MOBILE_HIDE_TAB_PREFIXES.some((p) => pathname.startsWith(p))) return false;
  return MOBILE_TAB_ROUTES.some((t) => t.to && (pathname === t.to || (t.to !== '/' && pathname.startsWith(t.to))));
}

export function getMobileScreenTitle(pathname, t) {
  const map = {
    '/': t('mobile.tabs.home'),
    '/forts': t('mobile.tabs.forts'),
    '/trek-planner': t('mobile.tabs.trek'),
    '/temples': t('mobile.tabs.temples'),
    '/search': t('mobile.actions.search'),
    '/nearby-forts': t('mobile.actions.nearby'),
    '/events': t('mobile.actions.events'),
    '/heritage': t('mobile.actions.heritage'),
    '/profile': t('fortDetail.myProfile'),
    '/mobile/settings': t('mobile.settings.title'),
  };
  if (map[pathname]) return map[pathname];
  if (pathname.startsWith('/fort/')) return t('mobile.tabs.forts');
  if (pathname.startsWith('/temples/')) return t('mobile.tabs.temples');
  return 'Gadkot';
}
